import React from "react";

const BookmarkSettings = () => {
  return <div>bookmark</div>;
};

export default BookmarkSettings;
